import { IconProps } from "../../../types/style";

const BigCompanyIcon = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M16.667 9.88006V29.3334H5.44029C3.89362 29.3334 2.62695 28.0934 2.62695 26.5734V6.78673C2.62695 3.29339 5.24029 1.70673 8.42695 3.26673L14.3336 6.18672C15.6136 6.81339 16.667 8.48006 16.667 9.88006Z"
          fill={color}
        />
        <path
          d="M11.9599 13H7.33325C6.78659 13 6.33325 12.5467 6.33325 12C6.33325 11.4533 6.78659 11 7.33325 11H11.9599C12.5066 11 12.9599 11.4533 12.9599 12C12.9599 12.5467 12.5199 13 11.9599 13Z"
          fill={color}
        />
        <path
          d="M11.9599 18.3333H7.33325C6.78659 18.3333 6.33325 17.8799 6.33325 17.3333C6.33325 16.7866 6.78659 16.3333 7.33325 16.3333H11.9599C12.5066 16.3333 12.9599 16.7866 12.9599 17.3333C12.9599 17.8799 12.5199 18.3333 11.9599 18.3333Z"
          fill={color}
        />
        <path
          opacity="0.6"
          d="M29.3334 20.0666V26C29.3334 27.84 27.8401 29.3333 26.0001 29.3333H16.6667V13.8933L17.2934 14.0266L22.6801 15.2266L23.3201 15.3733L26.0401 15.9866C26.6934 16.12 27.2934 16.3466 27.8134 16.68C27.8134 16.6933 27.8267 16.6933 27.8267 16.6933C27.9601 16.7866 28.0934 16.8933 28.2134 17.0133C28.8267 17.6266 29.2267 18.52 29.3201 19.8266C29.3201 19.9066 29.3334 19.9866 29.3334 20.0666Z"
          fill={color}
        />
        <path
          d="M16.6667 13.8933V21.8933C17.2801 22.7066 18.2401 23.2266 19.3334 23.2266C21.1867 23.2266 22.6801 21.7333 22.6801 19.8933V15.24L17.2934 14.04L16.6667 13.8933Z"
          fill={color}
        />
        <path
          d="M29.3197 19.8266C29.2264 18.5199 28.8264 17.6266 28.213 17.0132C28.093 16.8932 27.9597 16.7866 27.8264 16.6932C27.8264 16.6932 27.813 16.6932 27.813 16.6799C27.293 16.3466 26.693 16.1199 26.0397 15.9866L23.3197 15.3732L22.6797 15.2266V19.8932C22.6797 21.7199 24.1597 23.2266 26.013 23.2266C27.7997 23.2266 29.2264 21.8266 29.333 20.0799V20.0666C29.333 19.9866 29.3197 19.9066 29.3197 19.8266Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default BigCompanyIcon;
